// tslint:disable
/**
 * まなびスタンプ 問題マスタAPI
 * components はアルファベット順で記述しましょう。
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * コースID
 * @export
 * @enum {string}
 */
export enum CourseId {
    calc = 'calc',
    japanese = 'japanese',
    number = 'number',
    word = 'word'
}

/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof ErrorResponse
     */
    status: HttpStatusCode;
    /**
     * APIパス
     * @type {string}
     * @memberof ErrorResponse
     */
    path: string;
    /**
     * 発生日時
     * @type {string}
     * @memberof ErrorResponse
     */
    timestamp: string;
    /**
     * エラー概要
     * @type {string}
     * @memberof ErrorResponse
     */
    error: string;
    /**
     * エラー概要
     * @type {string}
     * @memberof ErrorResponse
     */
    message: string;
    /**
     * エラー詳細
     * @type {string}
     * @memberof ErrorResponse
     */
    trace?: string;
    /**
     * 例外クラス
     * @type {string}
     * @memberof ErrorResponse
     */
    exception?: string;
    /**
     * 入力エラー内容(status=400 の場合のみ)
     * @type {Array<FieldErrorResponse>}
     * @memberof ErrorResponse
     */
    errors?: Array<FieldErrorResponse>;
}
/**
 * 入力フィールドエラー
 * @export
 * @interface FieldErrorResponse
 */
export interface FieldErrorResponse {
    /**
     * 入力フィールド
     * @type {string}
     * @memberof FieldErrorResponse
     */
    field: string;
    /**
     * 入力オブジェクト
     * @type {string}
     * @memberof FieldErrorResponse
     */
    objectName: string;
    /**
     * エラー内容
     * @type {string}
     * @memberof FieldErrorResponse
     */
    defaultMessage: string;
}
/**
 * HTTPステータスコード
 * @export
 * @enum {string}
 */
export enum HttpStatusCode {
    badRequest = 400,
    unauthorized = 401,
    forbidden = 403,
    notFound = 404,
    requestTimeout = 408,
    internalServerError = 500
}


/**
 * QuestionApi - axios parameter creator
 * @export
 */
export const QuestionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 指定コース/単元の問題一覧を取得します　※問題一覧はファイルから取得
         * @summary 問題一覧
         * @param {CourseId} courseId コースID
         * @param {string} sectionCode 単元コード（&#x60;section{sectionNoを左0詰めで2桁にした文字列}&#x60;）
         * @param {string} questionsFile 問題一覧ファイル名（&#x60;section{sectionNoを左0詰めで2桁にした文字列}.txt&#x60;）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestion(courseId: CourseId, sectionCode: string, questionsFile: string, options: any = {}): RequestArgs {
            // verify required parameter 'courseId' is not null or undefined
            if (courseId === null || courseId === undefined) {
                throw new RequiredError('courseId','Required parameter courseId was null or undefined when calling listQuestion.');
            }
            // verify required parameter 'sectionCode' is not null or undefined
            if (sectionCode === null || sectionCode === undefined) {
                throw new RequiredError('sectionCode','Required parameter sectionCode was null or undefined when calling listQuestion.');
            }
            // verify required parameter 'questionsFile' is not null or undefined
            if (questionsFile === null || questionsFile === undefined) {
                throw new RequiredError('questionsFile','Required parameter questionsFile was null or undefined when calling listQuestion.');
            }
            const localVarPath = `/{courseId}/{sectionCode}/{questionsFile}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"sectionCode"}}`, encodeURIComponent(String(sectionCode)))
                .replace(`{${"questionsFile"}}`, encodeURIComponent(String(questionsFile)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定テキスト、または画像/音声/動画のバイナリを取得します  ※application/octet-streamだとレスポンス受け取れないので Media typeのプルダウンをapplication/jsonに切り替えてください 
         * @summary 問題テキスト、または画像/音声/動画バイナリ
         * @param {CourseId} courseId コースID
         * @param {string} sectionCode 単元コード（&#x60;section{sectionNoを左0詰めで2桁にした文字列}&#x60;）
         * @param {string} questionFile 問題テキスト/画像/音声/動画ファイル名（※コースごとにフォーマットあり）  計算：&#x60;{sectionNoを左0詰めで2桁にした文字列}-{questionNoを左0詰めで3桁にした文字列}{q または a}.svg&#x60;  読解：&#x60;{sectionNoを左0詰めで2桁にした文字列}-{questionNoを左0詰めで3桁にした文字列}{q または a}.txt&#x60; 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showQuestion(courseId: CourseId, sectionCode: string, questionFile: string, options: any = {}): RequestArgs {
            // verify required parameter 'courseId' is not null or undefined
            if (courseId === null || courseId === undefined) {
                throw new RequiredError('courseId','Required parameter courseId was null or undefined when calling showQuestion.');
            }
            // verify required parameter 'sectionCode' is not null or undefined
            if (sectionCode === null || sectionCode === undefined) {
                throw new RequiredError('sectionCode','Required parameter sectionCode was null or undefined when calling showQuestion.');
            }
            // verify required parameter 'questionFile' is not null or undefined
            if (questionFile === null || questionFile === undefined) {
                throw new RequiredError('questionFile','Required parameter questionFile was null or undefined when calling showQuestion.');
            }
            const localVarPath = `/{courseId}/{sectionCode}/{questionFile}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"sectionCode"}}`, encodeURIComponent(String(sectionCode)))
                .replace(`{${"questionFile"}}`, encodeURIComponent(String(questionFile)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionApi - functional programming interface
 * @export
 */
export const QuestionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 指定コース/単元の問題一覧を取得します　※問題一覧はファイルから取得
         * @summary 問題一覧
         * @param {CourseId} courseId コースID
         * @param {string} sectionCode 単元コード（&#x60;section{sectionNoを左0詰めで2桁にした文字列}&#x60;）
         * @param {string} questionsFile 問題一覧ファイル名（&#x60;section{sectionNoを左0詰めで2桁にした文字列}.txt&#x60;）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestion(courseId: CourseId, sectionCode: string, questionsFile: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = QuestionApiAxiosParamCreator(configuration).listQuestion(courseId, sectionCode, questionsFile, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 指定テキスト、または画像/音声/動画のバイナリを取得します  ※application/octet-streamだとレスポンス受け取れないので Media typeのプルダウンをapplication/jsonに切り替えてください 
         * @summary 問題テキスト、または画像/音声/動画バイナリ
         * @param {CourseId} courseId コースID
         * @param {string} sectionCode 単元コード（&#x60;section{sectionNoを左0詰めで2桁にした文字列}&#x60;）
         * @param {string} questionFile 問題テキスト/画像/音声/動画ファイル名（※コースごとにフォーマットあり）  計算：&#x60;{sectionNoを左0詰めで2桁にした文字列}-{questionNoを左0詰めで3桁にした文字列}{q または a}.svg&#x60;  読解：&#x60;{sectionNoを左0詰めで2桁にした文字列}-{questionNoを左0詰めで3桁にした文字列}{q または a}.txt&#x60; 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showQuestion(courseId: CourseId, sectionCode: string, questionFile: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = QuestionApiAxiosParamCreator(configuration).showQuestion(courseId, sectionCode, questionFile, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * QuestionApi - factory interface
 * @export
 */
export const QuestionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 指定コース/単元の問題一覧を取得します　※問題一覧はファイルから取得
         * @summary 問題一覧
         * @param {CourseId} courseId コースID
         * @param {string} sectionCode 単元コード（&#x60;section{sectionNoを左0詰めで2桁にした文字列}&#x60;）
         * @param {string} questionsFile 問題一覧ファイル名（&#x60;section{sectionNoを左0詰めで2桁にした文字列}.txt&#x60;）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestion(courseId: CourseId, sectionCode: string, questionsFile: string, options?: any): AxiosPromise<string> {
            return QuestionApiFp(configuration).listQuestion(courseId, sectionCode, questionsFile, options)(axios, basePath);
        },
        /**
         * 指定テキスト、または画像/音声/動画のバイナリを取得します  ※application/octet-streamだとレスポンス受け取れないので Media typeのプルダウンをapplication/jsonに切り替えてください 
         * @summary 問題テキスト、または画像/音声/動画バイナリ
         * @param {CourseId} courseId コースID
         * @param {string} sectionCode 単元コード（&#x60;section{sectionNoを左0詰めで2桁にした文字列}&#x60;）
         * @param {string} questionFile 問題テキスト/画像/音声/動画ファイル名（※コースごとにフォーマットあり）  計算：&#x60;{sectionNoを左0詰めで2桁にした文字列}-{questionNoを左0詰めで3桁にした文字列}{q または a}.svg&#x60;  読解：&#x60;{sectionNoを左0詰めで2桁にした文字列}-{questionNoを左0詰めで3桁にした文字列}{q または a}.txt&#x60; 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showQuestion(courseId: CourseId, sectionCode: string, questionFile: string, options?: any): AxiosPromise<string> {
            return QuestionApiFp(configuration).showQuestion(courseId, sectionCode, questionFile, options)(axios, basePath);
        },
    };
};

/**
 * QuestionApi - object-oriented interface
 * @export
 * @class QuestionApi
 * @extends {BaseAPI}
 */
export class QuestionApi extends BaseAPI {
    /**
     * 指定コース/単元の問題一覧を取得します　※問題一覧はファイルから取得
     * @summary 問題一覧
     * @param {CourseId} courseId コースID
     * @param {string} sectionCode 単元コード（&#x60;section{sectionNoを左0詰めで2桁にした文字列}&#x60;）
     * @param {string} questionsFile 問題一覧ファイル名（&#x60;section{sectionNoを左0詰めで2桁にした文字列}.txt&#x60;）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionApi
     */
    public listQuestion(courseId: CourseId, sectionCode: string, questionsFile: string, options?: any) {
        return QuestionApiFp(this.configuration).listQuestion(courseId, sectionCode, questionsFile, options)(this.axios, this.basePath);
    }

    /**
     * 指定テキスト、または画像/音声/動画のバイナリを取得します  ※application/octet-streamだとレスポンス受け取れないので Media typeのプルダウンをapplication/jsonに切り替えてください 
     * @summary 問題テキスト、または画像/音声/動画バイナリ
     * @param {CourseId} courseId コースID
     * @param {string} sectionCode 単元コード（&#x60;section{sectionNoを左0詰めで2桁にした文字列}&#x60;）
     * @param {string} questionFile 問題テキスト/画像/音声/動画ファイル名（※コースごとにフォーマットあり）  計算：&#x60;{sectionNoを左0詰めで2桁にした文字列}-{questionNoを左0詰めで3桁にした文字列}{q または a}.svg&#x60;  読解：&#x60;{sectionNoを左0詰めで2桁にした文字列}-{questionNoを左0詰めで3桁にした文字列}{q または a}.txt&#x60; 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionApi
     */
    public showQuestion(courseId: CourseId, sectionCode: string, questionFile: string, options?: any) {
        return QuestionApiFp(this.configuration).showQuestion(courseId, sectionCode, questionFile, options)(this.axios, this.basePath);
    }

}


/**
 * SectionApi - axios parameter creator
 * @export
 */
export const SectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 指定コースIDの単元一覧TSV（全件）を取得します　※単元一覧はファイルから取得
         * @summary 単元一覧
         * @param {CourseId} courseId コースID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSection(courseId: CourseId, options: any = {}): RequestArgs {
            // verify required parameter 'courseId' is not null or undefined
            if (courseId === null || courseId === undefined) {
                throw new RequiredError('courseId','Required parameter courseId was null or undefined when calling listSection.');
            }
            const localVarPath = `/{courseId}/m_section.txt`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SectionApi - functional programming interface
 * @export
 */
export const SectionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 指定コースIDの単元一覧TSV（全件）を取得します　※単元一覧はファイルから取得
         * @summary 単元一覧
         * @param {CourseId} courseId コースID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSection(courseId: CourseId, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = SectionApiAxiosParamCreator(configuration).listSection(courseId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SectionApi - factory interface
 * @export
 */
export const SectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 指定コースIDの単元一覧TSV（全件）を取得します　※単元一覧はファイルから取得
         * @summary 単元一覧
         * @param {CourseId} courseId コースID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSection(courseId: CourseId, options?: any): AxiosPromise<string> {
            return SectionApiFp(configuration).listSection(courseId, options)(axios, basePath);
        },
    };
};

/**
 * SectionApi - object-oriented interface
 * @export
 * @class SectionApi
 * @extends {BaseAPI}
 */
export class SectionApi extends BaseAPI {
    /**
     * 指定コースIDの単元一覧TSV（全件）を取得します　※単元一覧はファイルから取得
     * @summary 単元一覧
     * @param {CourseId} courseId コースID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionApi
     */
    public listSection(courseId: CourseId, options?: any) {
        return SectionApiFp(this.configuration).listSection(courseId, options)(this.axios, this.basePath);
    }

}


